const state = {
  name: ''
}

const mutations = {
  updateNameAtual (state, res) {
    state.name = res
  }
}

const actions = {
  updateName (context, data) {
    context.commit('updateNameAtual', data)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Users.js